export default __webpack_public_path__ + "static/media/667.28c5eb36.png";